export default __webpack_public_path__ + "static/media/d42.8b65b39f.png";